"use client";

import { ButtonTypes } from "./Button";
import { ButtonIcons } from "./ButtonIcons";
import { ComponentProps } from "react";

type ButtonProps = {
  btnClassName: string;
  isDownload: boolean;
  type: ButtonTypes;
  children: React.ReactNode;
  props: ComponentProps<"button">;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};
const ButtonClient = ({
  btnClassName,
  isDownload,
  type,
  children,
  props,
  onClick,
}: ButtonProps) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    onClick?.(e);
  };
  return (
    <button
      onClick={handleClick}
      className={`${btnClassName} button-reset`}
      aria-label={props["aria-label"] ?? ""}
      {...(props as ComponentProps<"button">)}
    >
      <ButtonIcons type={type} isDownload={isDownload} />
      {children}
    </button>
  );
};

export default ButtonClient;
